import { gql } from "@apollo/client";

import { AssessmentSuggestionFragments } from "@apps/assessments/graphql/get-assessment-suggested-answers-query";

export default gql`
  ${AssessmentSuggestionFragments}
  mutation regenerateAssessmentAnswers($assessmentId: Int!, $questionId: Int!) {
    regenerateQuestionAnswer(
      assessmentId: $assessmentId
      questionId: $questionId
    ) {
      assessment {
        id
        suggestedAnswers {
          edges {
            node {
              ...AssessmentSuggestedAnswer
            }
          }
        }
      }
    }
  }
`;
